// Routes whose server loaders call getActiveLocation() and therefore render
// different data per venue. Only these justify prompting a first-time visitor
// to pick a venue. Everything else (a deep-linked payment page, bookings,
// profile, pass) renders the same regardless of venue.
const VENUE_AWARE_ROUTES = [
  '/book',
  '/packages',
  '/memberships',
  '/coaches',
  '/class-categories',
];

function matchesRoute(pathname: string, route: string): boolean {
  return pathname === route || pathname.startsWith(`${route}/`);
}

/** Native app: prompt on the home screen and every venue-aware route. */
export function shouldPromptNativeFirstPick(pathname: string): boolean {
  if (pathname === '/') return true;
  return VENUE_AWARE_ROUTES.some((route) => matchesRoute(pathname, route));
}

// Web catalog listings whose offers are venue-scoped. Narrower than native:
// - `/` is the public marketing landing, so a modal there blocks first-time
//   visitors (and crawlers) before they have seen anything.
// - `/book` already renders its own inline location picker and requires a
//   choice before showing slots; a second prompt over it would duplicate it.
// - Detail pages (a membership, a coach) and payment returns are reached from
//   a link that already implies what the visitor wants.
const WEB_PROMPT_ROUTES = ['/packages', '/book/packages', '/memberships', '/coaches'];

/**
 * Web: prompt only on the catalog listings above, and never when the URL
 * already names the venue (`?location=`, which wins over the cookie
 * server-side) or deep-links a specific offer (`?package=`), where a modal
 * would hide the thing the visitor came for.
 */
export function shouldPromptWebFirstPick(pathname: string): boolean {
  const isCatalog =
    WEB_PROMPT_ROUTES.includes(pathname) ||
    pathname.startsWith('/class-categories/');
  if (!isCatalog) return false;

  const params = new URLSearchParams(window.location.search);
  return !params.has('location') && !params.has('package');
}
